import { useCallback, useMemo } from 'react';
import { authService } from '../services/api';

export const usePermisos = () => {
  const user = authService.getCurrentUser();
  const permisos = useMemo(() => user?.permisos || {}, [user]);
  const isSuperAdmin = user?.rol === 'super_admin';

  const hasModule = useCallback((modulo) => {
    if (isSuperAdmin) return true;
    const modulePerms = permisos[modulo];
    if (!modulePerms) {
      return false;
    }
    return Object.values(modulePerms).some(Boolean);
  }, [permisos, isSuperAdmin]);

  const can = useCallback((modulo, permiso = 'ver') => {
    if (isSuperAdmin) return true;
    const modulePerms = permisos[modulo];
    if (!modulePerms) {
      return false;
    }
    return !!modulePerms[permiso];
  }, [permisos, isSuperAdmin]);

  return { user, permisos, can, hasModule };
};


